import React from 'react';

interface JsonLdProps {
  schema: Record<string, any>;
}

/**
 * In Next.js App Router, some JSON-LD is better handled via
 * metadata, but for component-level schema (like individual Portfolio projects),
 * this allows injecting specialized structured data.
 * 
 * This is implemented as a Server Component for better performance and to 
 * avoid ChunkLoadErrors in the root layout.
 */
const JsonLd = ({ schema }: JsonLdProps) => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default JsonLd;
